export type Listing = {
  _id: string;
  slug: string;
  ownerName: string;
  ownerId?: string;
  ownerAvatarUrl?: string;
  title: string;
  subject: string;
  city: string;
  price: number;
  slotPricingEnabled?: boolean;
  rating: number;
  reviews: number;
  tags: string[];
  experience: string;
  availability: string;
  description: string;
  isOnline?: boolean;
  studentBookingDefaultZoomEnabled?: boolean;
  isFeatured?: boolean;
  featuredRank?: number;
  scheduleSlots?: {
    day: string;
    start: string;
    end: string;
    price?: number;
  }[];
  profileSections: {
    aboutMe: string;
    studentLevels: string[];
    lessonFormats: string[];
    firstLesson: {
      enabled: boolean;
      label: string;
    };
  };
  status?: "draft" | "active";
};

export const listings: Listing[] = [
  {
    _id: "t1",
    slug: "marie-lefevre",
    ownerName: "Marie Lefevre",
    ownerAvatarUrl:
      "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=facearea&w=800&h=800&q=80",
    title: "Préparation Bac & Concours",
    subject: "Mathématiques",
    city: "Paris",
    price: 38,
    rating: 4.9,
    reviews: 128,
    tags: ["Terminale", "Prépa", "Analyse"],
    experience: "8 ans d'expérience, agrégée de mathématiques.",
    availability: "Soirs & week-ends",
    description:
      "Cours structurés, exercices ciblés et suivi hebdomadaire. Spécialiste des concours.",
    isOnline: true,
    scheduleSlots: [
      { day: "Lundi", start: "18:00", end: "20:00" },
      { day: "Mercredi", start: "17:00", end: "19:00" },
    ],
    profileSections: {
      aboutMe:
        "Professeure agrégée passionnée par la pédagogie active et les concours.",
      studentLevels: ["lycee", "superieur"],
      lessonFormats: ["online", "intensif"],
      firstLesson: { enabled: true, label: "Premier échange offert" },
    },
  },
  {
    _id: "t2",
    slug: "ines-martin",
    ownerName: "Inès Martin",
    ownerAvatarUrl:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=facearea&w=800&h=800&q=80",
    title: "Méthodologie Bac Français",
    subject: "Français",
    city: "Lyon",
    price: 32,
    rating: 4.8,
    reviews: 95,
    tags: ["Bac", "Méthodologie", "Dissertation"],
    experience: "6 ans d'enseignement et d'accompagnement au bac.",
    availability: "Après-midi",
    description:
      "Préparation orale et écrite, fiches de révision et coaching confiance.",
    scheduleSlots: [
      { day: "Lundi", start: "16:00", end: "18:00" },
      { day: "Vendredi", start: "17:00", end: "19:00" },
    ],
    profileSections: {
      aboutMe:
        "J'accompagne les élèves avec une méthode claire et progressive axée bac.",
      studentLevels: ["college", "lycee"],
      lessonFormats: ["online", "domicile"],
      firstLesson: { enabled: true, label: "Diagnostic gratuit 30 min" },
    },
  },
  {
    _id: "t3",
    slug: "thomas-petit",
    ownerName: "Thomas Petit",
    ownerAvatarUrl:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=facearea&w=800&h=800&q=80",
    title: "Physique-Chimie Expériences",
    subject: "Physique-Chimie",
    city: "Lille",
    price: 35,
    rating: 4.7,
    reviews: 74,
    tags: ["Seconde", "Première", "Expériences"],
    experience: "Doctorant en physique, 5 ans de tutorat.",
    availability: "Matins",
    description:
      "Approche concrète, fiches méthode, suivi personnalisé par objectifs.",
    scheduleSlots: [
      { day: "Mercredi", start: "14:00", end: "16:00" },
      { day: "Samedi", start: "10:00", end: "12:00" },
    ],
    profileSections: {
      aboutMe:
        "Doctorant en physique, j'aime relier théorie et pratique pour progresser vite.",
      studentLevels: ["lycee", "superieur"],
      lessonFormats: ["online", "groupe"],
      firstLesson: { enabled: false, label: "" },
    },
  },
  {
    _id: "t4",
    slug: "sara-benali",
    ownerName: "Sara Benali",
    ownerAvatarUrl:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=facearea&w=800&h=800&q=80",
    title: "Anglais TOEIC Pro",
    subject: "Anglais",
    city: "Bordeaux",
    price: 30,
    rating: 4.9,
    reviews: 110,
    tags: ["Conversation", "TOEIC", "Business"],
    experience: "Coach bilingue, 7 ans d'expérience.",
    availability: "Flexibles",
    description: "Cours dynamiques, préparation TOEIC, anglais professionnel.",
    scheduleSlots: [
      { day: "Mardi", start: "18:00", end: "20:00" },
      { day: "Jeudi", start: "18:00", end: "20:00" },
    ],
    profileSections: {
      aboutMe:
        "Coach bilingue orientée objectifs, avec un suivi concret entre les séances.",
      studentLevels: ["lycee", "adultes"],
      lessonFormats: ["online", "intensif"],
      firstLesson: { enabled: true, label: "Premier cours d'essai offert" },
    },
  },
];

export const cities = [
  "Paris",
  "Marseille",
  "Lyon",
  "Toulouse",
  "Nice",
  "Nantes",
  "Montpellier",
  "Strasbourg",
  "Bordeaux",
  "Lille",
  "Rennes",
  "Reims",
  "Le Havre",
  "Saint-Étienne",
  "Toulon",
  "Grenoble",
  "Dijon",
  "Angers",
  "Villeurbanne",
  "Le Mans",
  "Aix-en-Provence",
  "Clermont-Ferrand",
  "Brest",
  "Limoges",
  "Tours",
  "Amiens",
  "Metz",
  "Perpignan",
  "Besançon",
  "Orléans",
];

/**
 * Repli utilisé tant que `/api/subjects` n'a pas répondu — notamment pendant le
 * rendu serveur, où les hooks client ne sont pas encore résolus.
 *
 * Ces libellés DOIVENT correspondre exactement au champ `name` des documents
 * `Subject` en base : les liens `/cours/{matiere}` sont construits avec
 * `slugify(nom)`, et `Subject.slug` est dérivé de la même façon côté serveur
 * (`backend/src/models/Subject.js`). Un libellé absent de la base produit donc
 * une URL en 404, rendue uniquement dans le HTML serveur — invisible dans le
 * navigateur, mais vue par les robots d'indexation.
 *
 * Toute modification doit rester alignée avec la collection `subjects`.
 */
export const subjects = [
  "Mathématiques",
  "Physique-Chimie (PC)",
  "Sciences de la vie et de la Terre (SVT)",
  "Numérique et Sciences Informatiques (NSI)",
  "Sciences de l'ingénieur (SI)",
  "Sciences économiques et sociales (SES)",
  "Histoire-Géographie, Géopolitique et Sciences Politiques (HGGSP)",
  "Humanités, Littérature et Philosophie (HLP)",
  "Langues, littératures et cultures étrangères (LLCE)",
  "Langues, littératures et cultures étrangères et régionales (LLCER)",
  "Littérature, langues et cultures de l'Antiquité (LLCA)",
  "Biologie-écologie",
  "Éducation physique, pratiques et culture sportives (EPPCS)",
  "Arts - Arts du cirque",
  "Arts - Arts plastiques (AP)",
  "Arts - Cinéma-audiovisuel (CAV)",
  "Arts - Danse",
  "Arts - Histoire des arts (HDA)",
  "Arts - Musique",
  "Arts - Théâtre",
];

export const highSchoolSubjects = subjects;
